import React from 'react';

const rentalFilter = props => {
  const { keywords } = props;

  if (keywords.length === 0) {
    return null;
  }

  return (
    <div>
      <h3 className="mb-3 text-lg font-medium">Popular RV Types & Amenities</h3>
      <div className="flex flex-wrap">
        {keywords.map(keyword => {
          return (
            <a
              className="px-4 py-2 mb-2 mr-2 text-sm text-gray-900 bg-gray-200 rounded-full shadow hover:shadow-md"
              href={keyword.url}
              key={keyword.title}>
              {keyword.title}
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default rentalFilter;
